import * as types from '../actions/types.action';
import initialState from './initial.state';
import {FEEDBACK_RESULT} from '../constants/constants';

const keepErrorsFor = (itemErrors, itemIds) =>
  itemIds.reduce(
    (kept, itemId) =>
      itemId in itemErrors ? {...kept, [itemId]: itemErrors[itemId]} : kept,
    {}
  );

export default function orderFeedbackReducer(
  state = initialState.orderFeedback,
  action
) {
  switch (action.type) {
    case types.GET_ORDER_FEEDBACK_SUCCESS:
      return {
        accountId: action.accountId,
        orderId: action.orderId,
        items: action.items,
        isOpen: true,
        // Set once the server has been told to snooze this popup.
        snoozed: false,
        submitting: false,
        result: null,
        itemErrors: {},
        alreadyReviewedItemIds: [],
      };
    case types.SUBMIT_ORDER_FEEDBACK_REQUESTED:
      // Already-reviewed items keep their message: they stay on screen,
      // locked, while the rest are sent again.
      return (
        state && {
          ...state,
          submitting: true,
          result: null,
          itemErrors: keepErrorsFor(
            state.itemErrors,
            state.alreadyReviewedItemIds
          ),
        }
      );
    case types.SUBMIT_ORDER_FEEDBACK_SUCCESS:
      return (
        state && {
          ...state,
          submitting: false,
          result: FEEDBACK_RESULT.SUCCESS,
        }
      );
    case types.SUBMIT_ORDER_FEEDBACK_FAILED:
      // Sent items leave the list, so only the ones to retry stay on screen.
      return (
        state && {
          ...state,
          items: state.items.filter(
            item => action.sentItemIds.indexOf(item.itemId) < 0
          ),
          submitting: false,
          itemErrors: {...state.itemErrors, ...action.itemErrors},
          alreadyReviewedItemIds: [
            ...state.alreadyReviewedItemIds,
            ...(action.alreadyReviewedItemIds || []),
          ],
          result: action.sentItemIds.length
            ? FEEDBACK_RESULT.PARTIAL
            : FEEDBACK_RESULT.FAILED,
        }
      );
    case types.SUBMIT_REVIEW_SUCCESS:
      return (
        state && {
          ...state,
          items: state.items.filter(item => item.itemId !== action.itemId),
        }
      );
    case types.ORDER_FEEDBACK_SNOOZED:
      return state && {...state, snoozed: true};
    case types.SNOOZE_ORDER_FEEDBACK:
    case types.DISMISS_ORDER_FEEDBACK:
      return state && {...state, isOpen: false};
    default:
      return state;
  }
}
